var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"locationHeader"},[_c('el-button',{staticClass:"locateButton",attrs:{"icon":"el-icon-map-location","plain":""},on:{"click":_vm.getLocationProcess}},[_vm._v(_vm._s(_vm.locationDescription))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }